// extracted by mini-css-extract-plugin
export default {"Callout":"JihIzXFv"};